import {PredicateOf} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ClientRequiredTaggingParameter} from '../../../../../../models/api/requiredTaggingModel';
import {
  RequiredTaggingParamsEditorAction,
  RequiredTaggingParamsEditorActionTypesEnum,
} from './requiredTaggingParamsEditorActions';
import {RequiredTaggingParamsEditorState} from './requiredTaggingParamsEditorState';

/*
 * Reducer.
 */

export function requiredTaggingParamsEditorReducer(
  state: RequiredTaggingParamsEditorState,
  action: RequiredTaggingParamsEditorAction,
): RequiredTaggingParamsEditorState {
  switch (action.type) {
    case RequiredTaggingParamsEditorActionTypesEnum.ADD_PARAMETER:
      return addParameter(state, action.parameter);

    case RequiredTaggingParamsEditorActionTypesEnum.UPDATE_PARAMETER:
      return updateParameter(state, action.predicate, action.update);

    case RequiredTaggingParamsEditorActionTypesEnum.DELETE_PARAMETER:
      return deleteParameter(state, action.predicate);

    default:
      return state;
  }
}

/*
 * Helpers.
 */

function addParameter(state: RequiredTaggingParamsEditorState, parameter: ClientRequiredTaggingParameter) {
  return {
    ...state,
    requiredTaggingParamsState: [...state.requiredTaggingParamsState, parameter],
  };
}

function updateParameter(
  state: RequiredTaggingParamsEditorState,
  predicate: PredicateOf<ClientRequiredTaggingParameter>,
  update: (requiredTaggingParams: ClientRequiredTaggingParameter) => ClientRequiredTaggingParameter,
) {
  return {
    ...state,
    requiredTaggingParamsState: state.requiredTaggingParamsState.map((parameterState) => {
      if (predicate(parameterState)) {
        return update(parameterState);
      }

      return parameterState;
    }),
  };
}

function deleteParameter(
  state: RequiredTaggingParamsEditorState,
  predicate: PredicateOf<ClientRequiredTaggingParameter>,
) {
  return {
    ...state,
    requiredTaggingParamsState: state.requiredTaggingParamsState.filter(
      (parameterState) => !predicate(parameterState),
    ),
  };
}
